import { useEffect, useState } from 'react';
import { Dropdown, Stack } from 'rsuite';
import PeoplesIcon from '@rsuite/icons/Peoples';
import {
  useAppDispatch,
  useAppSelector,
  useLazyRegionLoginQuery
} from '@monorepo/shared';
import {
  selectGroupRegions,
  selectHaCurrentGroup,
  selectHaGroups,
  updateHaCurrentGroup
} from '@monorepo/shared/store/groupSlice';

export const GroupDropdown = () => {
  const dispatch = useAppDispatch();
  const groups = useAppSelector(selectHaGroups);
  const groupRegions = useAppSelector(selectGroupRegions);
  const currentHaGroup = useAppSelector(selectHaCurrentGroup);

  const [regionLogin] = useLazyRegionLoginQuery();

  const onSelect = (item: any) => {
    dispatch(updateHaCurrentGroup(item));
  };

  useEffect(() => {
    if (Object.keys(groups).length > 0 && !currentHaGroup?.id) {
      const defaultGroup = getDefaultGroup(groups);
      if (defaultGroup) {
        dispatch(updateHaCurrentGroup(defaultGroup));
      }
    }
  }, [groups, currentHaGroup, dispatch]);

  useEffect(() => {
    if (Object.keys(groupRegions).length > 0) {
      const hasAnyToken = Object.values(groupRegions).some(
        (gr: any) => gr?.token
      );

      if (hasAnyToken) {
        Object.values(groupRegions).forEach((region: Record<string, any>) => {
          if (region?.globalToken && !region?.token) {
            regionLogin({ region, enableTimezone: true });
          }
        });
      }
    }
  }, [groupRegions, regionLogin]);

  if (!Object.values(groups).length) return null;

  return (
    <div className="group-dropdown">
      <Stack spacing={8}>
        <PeoplesIcon style={{ fontSize: '1.5em' }} />
        <div>
          <Dropdown
            // appearance="default"
            // size="sm"
            title={currentHaGroup?.desc || currentHaGroup?.name}
            // style={{ width: '100%' }}
          >
            {Object.values(groups).map((obj: Record<string, any>) => (
              <Dropdown.Item
                key={obj.id}
                style={{ padding: '10px 20px' }}
                onSelect={() => onSelect(obj)}
                active={currentHaGroup?.id === obj?.id}
              >
                {obj?.desc || `${obj?.region}|${obj?.name}`}
              </Dropdown.Item>
            ))}
          </Dropdown>
        </div>
      </Stack>
    </div>
  );
};

const getDefaultGroup = (groups: Record<string, any>) => {
  const list = Object.values(groups);

  if (!list.length) return null;

  // 1. FSOC + login token exists
  const fsocLoginRegion = list.find(
    (g: any) => g.name === 'FSOC' && g.regionObj?.token
  );
  if (fsocLoginRegion) return fsocLoginRegion;

  // 2. FSOC + is_default true
  const fsocDefault = list.find(
    (g: any) => g.name === 'FSOC' && g.regionObj?.is_default
  );
  if (fsocDefault) return fsocDefault;

  // 3. First FSOC
  const fsoc = list.find((g: any) => g.name === 'FSOC');
  if (fsoc) return fsoc;

  // 4. First item
  return list.find((g: any) => g.regionObj?.token) || list[0];
};

export default GroupDropdown;
